export default defineNuxtRouteMiddleware((to, from) => {
  const searchStore = useSearchStore();
  if (!searchStore.searchText) {
    return navigateTo("/");
  }
});
